var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video_preview_wrap" }, [
    _c("div", { staticClass: "video_preview_box" }, [
      _c("div", { staticClass: "video_head" }, [
        _c("p", { staticClass: "video_name" }, [_vm._v(_vm._s(_vm.videoName))]),
        _vm._v(" "),
        _c("span", {
          staticClass: "el-icon-circle-close close_btn",
          on: {
            click: function($event) {
              return _vm.closeFn()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "video",
        {
          ref: "videoC",
          staticClass: "video-js",
          style: "height:" + _vm.videoHeight,
          attrs: {
            id: "video",
            controls: "",
            controlsList: "nodownload",
            preload: "auto",
            width: "100%",
            "data-setup": '{"example_option":true}'
          }
        },
        [
          _c("source", {
            attrs: { id: "sourceBox", src: _vm.videoSrc, type: "video/mp4" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "vjs-no-js" }, [_vm._v("不支持播放")])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-521b3bde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-521b3bde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/components/videoPreview.vue
// module id = null
// module chunks = 